import { ShoppingItem, SceneItemData, RangeSettings } from 'sofa-reborn-react';
import { ProductData } from '@ikea-aoa/component-view-3d';
import { localeService } from '../services';

export class ProductConverter {
	public static getShoppingItemsFromScene(
		sceneItems: SceneItemData[],
		productData: ProductData,
		rangeSettings: RangeSettings,
		coverOnly: boolean
	): ShoppingItem[] {
		const countedItems: { [key: string]: ShoppingItem } = sceneItems.reduce(
			(result, sceneItem: SceneItemData) => {
				const { articleId } = sceneItem;
				const articleIdentity = articleId.replace('_mirror', '');
				const product = productData[articleIdentity];
				const countryCode = localeService.getCountryCode();
				const localSofabedMattressId = rangeSettings.localSofabedMattressId
					? rangeSettings.localSofabedMattressId[countryCode]
					: null;
				const globalSofabedMattressId = rangeSettings.globalSofabedMattressId
					? rangeSettings.globalSofabedMattressId
					: [];

				// Do not add leg articles or modules with no article ID to shoppingItems
				if (articleId !== 'leg' && !product.filter.noArticleId) {
					// Add spr articles if the spr id is invalid
					if (product && product.sprItems && (product.sprIdInvalid || coverOnly)) {
						product.sprItems.forEach((sprItem) => {
							const itemID =
								localSofabedMattressId &&
								globalSofabedMattressId &&
								globalSofabedMattressId.includes(sprItem.itemno)
									? localSofabedMattressId
									: sprItem.itemno;
							if (!result[itemID]) {
								// Create a new shopping item
								const item: ShoppingItem = {
									id: sprItem.localId || itemID,
									quantity: sprItem.qty,
									type: 'ART',
								};
								result[itemID] = item;
							} else {
								// Update quantity
								result[itemID].quantity += sprItem.qty;
							}
						});
					} else if (!result[articleIdentity]) {
						// create a new shopping item
						const item: ShoppingItem = {
							id: product.localId || articleIdentity,
							quantity: 1,
							type: product.type,
						};
						result[articleIdentity] = item;
					} else {
						// update the quantity
						result[articleIdentity].quantity++;
					}
				}
				return result;
			},
			{}
		);
		return Object.values(countedItems);
	}

	public static getChildItemsFromScene(
		sceneItems: SceneItemData[],
		productData: ProductData,
		rangeSettings: RangeSettings
	): ShoppingItem[] {
		const countedItems: { [key: string]: ShoppingItem } = sceneItems.reduce(
			(result, sceneItem: SceneItemData) => {
				const { articleId } = sceneItem;
				const articleIdentity = articleId.replace('_mirror', '');
				const product = productData[articleIdentity];
				const countryCode = localeService.getCountryCode();
				const localSofabedMattressId = rangeSettings.localSofabedMattressId
					? rangeSettings.localSofabedMattressId[countryCode]
					: null;
				const globalSofabedMattressId = rangeSettings.globalSofabedMattressId
					? rangeSettings.globalSofabedMattressId
					: [];

				if (product && product.sprItems) {
					product.sprItems.forEach((sprItem) => {
						const itemID =
							localSofabedMattressId &&
							globalSofabedMattressId &&
							globalSofabedMattressId.includes(sprItem.itemno)
								? localSofabedMattressId
								: sprItem.itemno;
						if (!result[itemID]) {
							// Create a new shopping item
							const item: ShoppingItem = {
								id: sprItem.localId || itemID,
								quantity: sprItem.qty,
								type: 'ART',
							};
							result[itemID] = item;
						} else {
							// Update quantity
							result[itemID].quantity += sprItem.qty;
						}
					});
				}
				return result;
			},
			{}
		);
		return Object.values(countedItems);
	}
}
